<script setup lang="ts">
const { value } = defineProps<{
  value: number
}>()
const indexColor = {
  1: '#CC0000',
  2: '#D63333',
  3: '#E06666',
  4: '#F99A34',
  5: '#FAAE5D',
  6: '#FBC285',
  7: '#3BD679',
  8: '#0ACC58',
  9: '#08A346',
  10: '#067A35',
} as const

type IndexColor = typeof indexColor

const colorKey = computed(() => {
  const closestKey = Math.round(value)
  return Math.max(1, Math.min(closestKey, 10)) as keyof IndexColor
})
</script>

<template>
  <span class="rounded-1/2 text-xs text-white w-6.5 h-6.5 flex justify-center items-center" :style="{ backgroundColor: indexColor[colorKey] }">
    {{ value }}
  </span>
</template>
